export default __webpack_public_path__ + "static/favicon-b2013630022354d47ef29d09092deb07.ico";